import { connect } from 'react-redux'
import { compose } from 'redux'
import { push } from 'connected-react-router'
import toJS from '../../../hoc/toJS'
import PageSocialMediaPost from '../present/PageSocialMediaPost'
import getData from '../../../functions/getData'
import { SOCIAL_MEDIA_DATA, PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_PERFORMANCES, PROGRAM_CINEMAS, THEME, FRONT } from '../../../constants/state'
import actionTypes from '../../../actions/actionTypes'
import config from '../../../config.json'

const mapStateToProps = (state, ownProps) => {
    const presetId = ownProps.match.params.presetId
    const presets  = state.getIn([SOCIAL_MEDIA_DATA, 'presets'])
    const preset   = presets ? presets.find(p => p.get('id') === presetId) : null

    return {
        preset:             preset || null,
        presets:            presets || null,
        presetId,
        cinemaId:           ownProps.match.params.cinemaId,
        movies:             getData(state, PROGRAM_CLI_MOVIES_ITEMS),
        performances:       getData(state, PROGRAM_PERFORMANCES),
        cinemas:            getData(state, PROGRAM_CINEMAS),
        themeData:          getData(state, THEME),
        front:              getData(state, FRONT),
        isDownloading:      state.getIn([SOCIAL_MEDIA_DATA, 'isDownloading']) || false,
        translationStrings: state.getIn(['translation', 'strings']),
        currentLang:        state.getIn(['translation', 'currentLang']),
        translationDebug:   state.getIn(['translation', 'debug']),
    }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    closePagePath: `${config.routes.socialMedia.path}/${ownProps.match.params.cinemaId}`,
    onBack: () => {
        const cinemaId = ownProps.match.params.cinemaId
        dispatch(push(`${config.routes.socialMedia.path}/${cinemaId}`))
    },
    onPresetChange: (newPresetId) => {
        const cinemaId = ownProps.match.params.cinemaId
        dispatch(push(`${config.routes.socialMedia.path}/${cinemaId}/post/${newPresetId}`))
    },
    onDownload: (images, formatId, customWidth, customHeight) => {
        dispatch({
            type:    actionTypes.SOCIAL_MEDIA_DOWNLOAD_REQUEST,
            payload: {
                images,
                formatId,
                customWidth,
                customHeight,
                presetId:  ownProps.match.params.presetId,
                cinemaId:  ownProps.match.params.cinemaId,
            },
        })
    },
})

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(PageSocialMediaPost)
